import type { ReactElement } from 'react';

import { useTranslation } from 'react-i18next';
import styles from '../styles';

export type TUtterancePhraseProps = {
  utterancePhrase: string;
};

const ContactSheetUtterancePhrase = ({ utterancePhrase }: TUtterancePhraseProps): ReactElement => {
  const { t } = useTranslation();
  return (
    <div css={styles.utterancePhraseContainer}>
      <div css={styles.utterancePhraseText}>{t('global.askSpeakerToPlay')}</div>
      <div css={styles.utterancePhraseText}>
        <b>
          {utterancePhrase} {t('global.onAudacy')}
        </b>
      </div>
    </div>
  );
};

export default ContactSheetUtterancePhrase;
